var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("div", { staticClass: "world-map-section" }),
      _vm._v(" "),
      _c("sdr-keydestinations", { attrs: { modulo: "flightplan" } }),
      _vm._v(" "),
      _c("sdr-flightplantable", {
        on: {
          clickdepartureairport: _vm.onClick_DepartureAirportInFlightplanTable,
          clickresetmap: _vm.onClick_ResetMap,
        },
      }),
      _vm._v(" "),
      _c("sdr-promobox-sundair-app"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }